import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import { Breakpoint } from '../types/breakpoint';
export default class RelatedProductsSlider {
    static $slider = $('.js__related-products-slider');
    static swiper;
    static options = {
        modules: [Pagination],
        centeredSlides: true,
        slidesPerView: 'auto',
        centerInsufficientSlides: true,
        spaceBetween: 24,
        watchOverflow: true,
        breakpoints: {
            [Breakpoint.lg]: {
                slidesPerView: 4,
                spaceBetween: 0,
                centeredSlides: false,
            },
        },
        pagination: {
            el: '.swiper-pagination',
        },
    };
    static init($root = $('body')) {
        this.$slider = $root.find('.js__related-products-slider');
        if (!this.$slider.length) {
            return;
        }
        this.swiper = new Swiper(this.$slider.get(0), this.options);
    }
}
